import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Card.module.css';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'highlighted';
  children: ReactNode;
}

export function Card({
  variant = 'default',
  children,
  className = '',
  ...rest
}: CardProps) {
  const classes = [
    styles.card,
    variant === 'highlighted' ? styles.highlighted : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
